import React from 'react'
import { profileContext } from './context';
import { ProfileProvider } from './provider';

const useProfile = () => {
  const { profile } = React.useContext(profileContext);
  return { profile };
}

export { useProfile, ProfileProvider }
